var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternetIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pepicons-pop:internet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8ZM13.8 8C13.8 9.53826 13.1889 11.0135 12.1012 12.1012C11.0135 13.1889 9.53826 13.8 8 13.8C6.46174 13.8 4.98649 13.1889 3.89878 12.1012C2.81107 11.0135 2.2 9.53826 2.2 8C2.2 6.46174 2.81107 4.98649 3.89878 3.89878C4.98649 2.81107 6.46174 2.2 8 2.2C9.53826 2.2 11.0135 2.81107 12.1012 3.89878C13.1889 4.98649 13.8 6.46174 13.8 8Z",
    fill: "#7D8A99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8.00002C5 11.6176 6.1928 14.6 8 14.6C9.8072 14.6 11 11.6176 11 8.00002C11 4.38242 9.8072 1.40002 8 1.40002C6.1928 1.40002 5 4.38242 5 8.00002ZM9.8 8.00002C9.8 11.0096 8.844 13.4 8 13.4C7.156 13.4 6.2 11.0096 6.2 8.00002C6.2 4.99042 7.156 2.60002 8 2.60002C8.844 2.60002 9.8 4.99042 9.8 8.00002Z",
    fill: "#7D8A99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.8815 4.37361L3.6863 3.48401C3.7663 3.55601 3.8535 3.62801 3.9463 3.69761C4.9631 4.45921 6.5863 4.92961 8.3583 4.92961C9.8711 4.92961 11.2807 4.58801 12.3031 4.00321C12.5495 3.86241 12.7687 3.70961 12.9583 3.54721L13.7375 4.46001C13.4772 4.68081 13.1965 4.87636 12.8991 5.04401C11.6863 5.73841 10.0719 6.12881 8.3583 6.12881C6.3407 6.12881 4.4663 5.58641 3.2263 4.65761C3.10707 4.56829 2.99201 4.47352 2.8815 4.37361ZM2.8815 11.6392L3.6863 12.5288C3.7663 12.456 3.8535 12.3848 3.9463 12.3152C4.9631 11.5536 6.5863 11.0832 8.3583 11.0832C9.8711 11.0832 11.2807 11.4248 12.3031 12.0096C12.5495 12.1504 12.7687 12.3032 12.9583 12.4656L13.7375 11.5528C13.4769 11.3324 13.1962 11.1369 12.8991 10.9688C11.6863 10.2744 10.0719 9.88401 8.3583 9.88401C6.3407 9.88401 4.4663 10.4264 3.2263 11.3552C3.10707 11.4445 2.99201 11.5393 2.8815 11.6392ZM1.3999 8.60001V7.40001H14.5999V8.60001H1.3999Z",
    fill: "#7D8A99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetIcon);
export default __webpack_public_path__ + "static/media/internet_icon.5ccb4e9342df94eab30f2c4ac9174338.svg";
export { ForwardRef as ReactComponent };